const key = (address: string) => `gamma.pending-wallet-send.v1:${address}`;

export const readPendingSend = (address: string) => localStorage.getItem(key(address));

export const savePendingSend = (address: string, intentId: string) =>
  localStorage.setItem(key(address), intentId);

export const clearPendingSend = (address: string, intentId: string) => {
  if (readPendingSend(address) === intentId) {
    localStorage.removeItem(key(address));
  }
};
